import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SelectionMode, CheckboxVisibility } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ContextualDetailsList, GridContextProvider } from '@bingads-webui-grid/grid-context';
import { columns } from './util/grid-columns';
import { GridDataSource } from './grid-data-source';
import { NoRecommendationWarning } from './no-recommendation-warning';
import { getGridStyles } from './style/grid-style';

export const KeywordRanking = ({
  allData,
  selectedData,
  onSelectChange,
}) => {
  const classes = useDefaultStyles(getGridStyles);
  const i18n = useContext(I18nContext);
  const gridColumns = useMemo(() => columns(i18n), [i18n]);
  const initialGridContext = useMemo(() => ({
    sortedColumn: {}, // [todo] initial sort column
    selectionMode: SelectionMode.multiple,
    allColumns: gridColumns,
    selectedColumns: gridColumns,
    initAllItems: allData,
    initSelectedItems: selectedData,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), []);

  return (
    <div className={classes.root}>
      <GridContextProvider {...initialGridContext}>
        <GridDataSource onSelectChange={onSelectChange} />
        <ContextualDetailsList
          placeholder={<NoRecommendationWarning />}
          stickyHeader
          checkboxVisibility={CheckboxVisibility.always}
        />
      </GridContextProvider>
    </div>
  );
};

KeywordRanking.propTypes = {
  allData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelectChange: PropTypes.func,
};

KeywordRanking.defaultProps = {
  onSelectChange: () => {},
};
